import React from 'react';
import {
  CUSTOM_HUB_CREATE_BUTTON_LABEL,
  CUSTOM_HUB_MANAGE_BUTTON_LABEL,
  CUSTOM_HUB_PUBLIC_GAMES_COMING_SOON_TEXT,
  CUSTOM_HUB_VIEW_CREATE,
  CUSTOM_HUB_VIEW_MANAGE,
} from '../../../constants/games/zoomedInCustomGame';
import './CustomGameHubCard.css';

const CustomGameHubCard = ({ activeView, onViewChange }) => {
  const isCreateActive = activeView === CUSTOM_HUB_VIEW_CREATE;
  const isManageActive = activeView === CUSTOM_HUB_VIEW_MANAGE;

  return (
    <section className="custom-game-hub-card" aria-label="Zoomed In Custom hub">
      <h2>Zoomed In Custom</h2>
      <p className="custom-game-hub-card__subtitle">Choose an action:</p>

      <div className="custom-game-hub-card__actions" role="group" aria-label="Custom game actions">
        <button
          type="button"
          className={`custom-game-hub-card__action ${isCreateActive ? 'custom-game-hub-card__action--active' : ''}`}
          aria-pressed={isCreateActive}
          onClick={() => onViewChange(CUSTOM_HUB_VIEW_CREATE)}
        >
          {CUSTOM_HUB_CREATE_BUTTON_LABEL}
        </button>
        <button
          type="button"
          className={`custom-game-hub-card__action ${isManageActive ? 'custom-game-hub-card__action--active' : ''}`}
          aria-pressed={isManageActive}
          onClick={() => onViewChange(CUSTOM_HUB_VIEW_MANAGE)}
        >
          {CUSTOM_HUB_MANAGE_BUTTON_LABEL}
        </button>
      </div>

      <p className="custom-game-hub-card__coming-soon">
        {CUSTOM_HUB_PUBLIC_GAMES_COMING_SOON_TEXT}
      </p>
    </section>
  );
};

export default CustomGameHubCard;
